import { useTranslation } from "react-i18next"
import { useEffect } from "react"
import CommonUtil from "../../../utils/CommonUtil"

const BindDeviceFaq = props => {
    const { t } = useTranslation()

    const postTitle = () => {
        if (CommonUtil.isInApp(navigator.userAgent)) {
            window.ReactNativeWebView.postMessage(t('bind_device_faq_title'))
        }
    }

    useEffect(() => {
        postTitle()
    }, [])
    return <div className="App">
        <div className="bind-device-faq">
            <span style={{ fontSize: 16, fontWeight: '500', color: '#000000', marginLeft: 25, marginTop: 15 }}>{t('bind_device_faq_step1')}</span>
            {/* <span style={{ fontSize: 14, fontWeight: '500', color: '#333333', marginLeft: 25, marginTop: 10 }}>{t('bind_device_faq_step1_action1')}</span> */}
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px' }}>{t('bind_device_faq_step1_action1_detail1')}</span>
                {/* <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px' }}>{t('bind_device_faq_step1_action1_detail2')}</span> */}
            </div>
            <div className="bind-device-faq-marginH20">
                <img src={`${CommonUtil.getSourceDomain()}bind_faq_step1_action1.png`} alt="" style={{ width: '100%', marginLeft: 20, marginTop: 15 }} />
            </div>
            <span style={{ fontSize: 14, fontWeight: '500', color: '#333333', marginLeft: 25, marginTop: 10 }}>{t('bind_device_faq_step1_action2')}</span>
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, whiteSpace: 'pre-line', lineHeight: '22px' }}>{t('bind_device_faq_step1_action2_detail1')}</span>
                {/* <span style={{ fontSize: 14, color: '#333333', marginTop: 10, whiteSpace: 'pre-line', lineHeight: '22px' }}>{t('bind_device_faq_step1_action2_detail2')}</span> */}
            </div>
            {/* <div className="bind-device-faq-marginH20">
                <img src={`${CommonUtil.getSourceDomain()}bind_faq_step1_action2.png`} alt="" style={{ width: '100%', marginLeft: 20, marginTop: 15 }} />
            </div> */}
            <span style={{ fontSize: 16, fontWeight: '500', color: '#000000', marginLeft: 25, marginTop: 25 }}>{t('bind_device_faq_step2')}</span>
            <span style={{ fontSize: 14, fontWeight: '500', color: '#333333', marginLeft: 25, marginTop: 10 }}>{t('bind_device_faq_step2_action1')}</span>
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px' }}>{t('bind_device_faq_step2_action1_detail1')}</span>
            </div>
            {/* <div className="bind-device-faq-marginH20">
                <img src={`${CommonUtil.getSourceDomain()}bind_faq_step2.png`} alt="" style={{ width: '100%', marginLeft: 20, marginTop: 15 }} />
            </div> */}
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px', whiteSpace: 'pre-line' }}>{t('bind_device_faq_step2_action1_detail2')}</span>
            </div>
            {/* <span style={{ fontSize: 14, fontWeight: '500', color: '#333333', marginLeft: 25, marginTop: 40 }}>{t('bind_device_faq_step2_action2')}</span> */}
            {/* <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px', whiteSpace: 'pre-line' }}>{t('bind_device_faq_step2_action2_detail1')}</span>
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px', whiteSpace: 'pre-line' }}>{t('bind_device_faq_step2_action2_detail2')}</span>
            </div> */}
            <div style={{ height: 100 }} />
        </div>
    </div>
}



export default BindDeviceFaq